import script from "./AirGroundLogistics.vue?vue&type=script&setup=true&lang=js"
export * from "./AirGroundLogistics.vue?vue&type=script&setup=true&lang=js"

import "./AirGroundLogistics.vue?vue&type=style&index=0&id=2bfcb138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bfcb138"]])

export default __exports__